import React, { useEffect, useState } from "react";
import { PropertiesListingWrapper } from "./styled";
import {
  Box,
  ButtonStyled,
  HeadingStyled,
  HeadingStyledSm,
  LabelStyled,
  SpanStyled,
} from "../../../../components/styled/Elements";
import { useTranslation } from "react-i18next";
import {
  BackArrow,
  BackwardArrow,
  ForwardArrow,
  LocationPin,
  PlaceholderImg,
  PlusIcon,
  ThreeDots,
  Thumbnail1,
  Thumbnail2,
  Thumbnail3,
  Whatsapp,
} from "../../../../components/styled/AllImages";
import { PropertyDropdownList } from "../../../../helpers/webConstants";
import ActionDropdown from "../../../../components/common/dropdowns/ActionDropdown";
import { PropertiesList } from "../../../../helpers/dummyConstants";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css"; // Core Swiper styles
import "swiper/css/navigation"; // Navigation styles (optional)
import "swiper/css/pagination"; // Pagination styles (optional)

// Import additional modules if needed
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import ForgetPasswordModal from "../../../../components/auth/Modal/ForgetPasswordModal";
import AddPropertyModal from "../../../../components/auth/Modal/AddPropertyModal";
import EditPropertyModal from "../../../../components/auth/Modal/EditPropertyModal";
import PropertiesApi from "../../../../services/api/propertiesApi";
import DeleteModal from "../../../../components/auth/Modal/DeleteModal";
import { toast } from "react-toastify";
import { formateAmounts } from "../../../../utils";
import UpdatedTooltip from "../../../../components/common/dropdowns/UpdatedTooltip";
import { useNavigate } from "react-router-dom";
import GalleryModal from "../../../../components/common/Modal/galleryModal/GalleryModal";

import { resolveMediaUrl } from "../../../../utils/mediaUrl";
import ListingCardMeta from "./ListingCardMeta";
import { useUser } from "../../../../context/userContext";

const PopertiesCards = ({ showAll, setShowAll }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const navigate = useNavigate();
  const { user } = useUser();
  const isVisitorSpecialization =
    Number(user?.fal_information?.specialization) === 4;
  const [isDesktop, setIsDesktop] = useState(window.innerWidth < 767);
  const [propertiesList, setPropertiesList] = useState([]);
  const [deletedImages, setDeletedImages] = useState([]);
  const [propertyId, setPropertyId] = useState({
    id: null,
    hashId: null,
  });
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [galleryImages, setGalleryImages] = useState([]);
  const [showGallery, setShowGallery] = useState(false);

  const [isFetching, setIsFetching] = useState(false);

  // Open & Close Modal
  const handleOpenModal = (hashId, id) => {
    setPropertyId({ hashId, id });
    setShowEditModal(true);
  };

  const handleGalleryOpen = (images) => {
    setGalleryImages(images);
    setShowGallery(true);
  };
  const handleGalleryClose = () => {
    setGalleryImages([]);
    setShowGallery(false);
  };

  const onDelete = (id) => {
    setPropertyId((prevData) => ({
      ...prevData,
      id,
    }));
    setShowDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      const { code, message } = await PropertiesApi.deleteSingleProperty(
        propertyId?.id
      );
      if (code === 200) {
        toast.success(t("property_deleted_successfully"));
        setShowDeleteModal(false);
        getPropertiesList();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };

  const handleMarkSold = async (hashId) => {
    try {
      const { code, message } = await PropertiesApi.changePropertyStatus(
        hashId
      );
      if (code === 200) {
        toast.success(t("status_updated_successfully"));
        getPropertiesList();
      }
      if (code === 100 || code === 204) {
        toast.error(message);
      }
    } catch (error) {}
  };
  // const handleCloseModal = () => setShowModal(false);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth < 767);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const getPropertiesList = async () => {
    try {
      setIsFetching(true);
      const { data, code } = await PropertiesApi.getPropertiesList();
      if (code === 200) {
        setPropertiesList(data);
      } else {
        setPropertiesList([]);
      }
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    getPropertiesList();
  }, [language]);

  return (
    <>
      <Box className="d-flex justify-content-between w-100 align-items-center mb-4">
        <Box className="d-flex gap-2 align-items-center">
          {showAll && (
            <BackArrow
              onClick={() => setShowAll(false)}
              style={{
                transform: language === "ar" ? "scale(-1)" : "scale(1)",
              }}
            />
          )}
          <HeadingStyled size="24px">{t("RealEstateListings")}</HeadingStyled>
        </Box>
        <ButtonStyled
          label={!isDesktop ? t("AddProperty") : t("add")}
          icon={!isDesktop && PlusIcon}
          bg="var(--themeColorSecondary)"
          onClick={() => {
            if (isVisitorSpecialization) {
              toast.error(t("visitor_specialization_cannot_publish"));
              return;
            }
            setShowModal(true);
          }}
        />
        {/* {isDesktop && !showAll && (
          <Box className="d-flex">
            <ButtonStyled
              label={t("ViewAll")}
              bg="var(--white)"
              border="var(--border)"
              color="var(--themeColorSecondary)"
              onClick={() => setShowAll(true)}
            />
          </Box>
        )} */}
      </Box>
      {propertiesList?.length > 0 ? (
        <Box
          className={`propertiesGridWrapper ${
            showAll && "flex-wrap overflow-visible"
          } `}
        >
          {propertiesList
            ?.slice(0, showAll ? propertiesList.length : 3)
            ?.map((item, key) => (
              <Box
                className={`px-1 ${
                  isDesktop && !showAll
                    ? "col-sm-6 col-9"
                    : isDesktop && showAll && "col-12"
                }`}
                key={key}
              >
                <Box className="colPropertiesGrid">
                  <Box className="propertyImgWrapper">
                    <Swiper
                      key={language}
                      modules={[Pagination, Navigation]}
                      slidesPerView={1}
                      pagination={{ dynamicBullets: true, clickable: true }}
                      // autoplay={false}
                      loop={true}
                      navigation={true}
                      dir={language === "ar" ? "rtl" : "ltr"}
                    >
                      {item?.media?.exterior_images?.length > 0 ? (
                        item?.media?.exterior_images?.map((image, index) => (
                          <SwiperSlide key={index} className="w-100">
                            <div className="slide-content w-100">
                              <img
                                src={resolveMediaUrl(image)}
                                alt={`thumbnail-${index}`}
                                className="w-100 object-fit-cover"
                                onClick={() => handleGalleryOpen(item?.media?.exterior_images)}
                              />
                            </div>
                          </SwiperSlide>
                        ))
                      ) : (
                        <SwiperSlide className="w-100">
                          <div className="slide-content w-100">
                            <img
                              src={PlaceholderImg}
                              alt={`thumbnail`}
                              className="w-100 object-fit-cover"
                            />
                          </div>
                        </SwiperSlide>
                      )}
                    </Swiper>
                    <SpanStyled
                      size="14px"
                      color="var(--white)"
                      className="propertyStatus"
                      bg={
                        Number(item?.marked_as_sold)
                          ? "var(--redColor)"
                          : "var(--green)"
                      }
                    >
                      {t(Number(item?.marked_as_sold) ? "Sold" : "available")}
                    </SpanStyled>
                  </Box>
                  <Box className="titleLocationWrapper">
                    <Box className="titleLocation">
                      <HeadingStyled size="18px">
                        {`${t(
                          Number(item?.listing_property_type?.id) === 7
                            ? language === "en"
                              ? item?.listing_property_type?.other_prop_type_en
                              : item?.listing_property_type?.other_prop_type_ar
                            : item?.listing_property_type?.name
                        )} ${t("for")} ${item?.listing_type?.name}`}
                      </HeadingStyled>
                      <Box className="peopleLocationRole mt-1">
                        <SpanStyled
                          size="14px"
                          color="var(--lightGrey)"
                          className="d-flex align-items-center gap-1"
                        >
                          <Box>
                            <LocationPin />
                          </Box>{" "}
                          {t(`${language === "en" ? item?.city : item?.city}`)}{" "}
                          {/* Replace with actual city name */}
                        </SpanStyled>
                        <SpanStyled size="14px" color="var(--lightGrey)">
                          {language === "en"
                            ? item?.neighborhood_data?.name_en
                            : item?.neighborhood_data?.name_ar}
                        </SpanStyled>
                      </Box>
                    </Box>
                    <Box
                      title={t("more_options")}
                      className="propertyActionDropdown mt-2"
                    >
                      <ActionDropdown
                        color="var(--darkGrey)"
                        paddingY={5}
                        paddingX={16}
                        itemsList={PropertyDropdownList}
                        property={item}
                        onEdit={handleOpenModal}
                        onDelete={onDelete}
                        onStatusChange={handleMarkSold}
                        title={<ThreeDots />}
                        hashId={item?.hash_id}
                        id={item?.id}
                      />
                    </Box>
                  </Box>

                  <Box className="px-2 px-lg-0 mb-3">
                    {item?.price && (
                      <Box className="d-flex gap-1 align-items-end mt-2">
                        <HeadingStyled
                          size="18px"
                          className="price-wrapper"
                        >
                          {formateAmounts(item?.price)} {t("sar")}
                        </HeadingStyled>
                      </Box>
                    )}
                  </Box>
                  <ListingCardMeta item={item} language={language} t={t} />
                  {item?.contact_phone && (
                    <Box className="px-2 px-lg-0 mb-2">
                      <SpanStyled size="14px" color="var(--lightGrey)">
                        {t("confirm_contact_number")}: {item.contact_phone}
                      </SpanStyled>
                    </Box>
                  )}
                  <Box className="d-flex justify-content-end flex-sm-nowrap flex-wrap gap-2 m-2 m-lg-0">
                    <ButtonStyled
                      label={t("view_details")}
                      bg="var(--themeColorSecondary)"
                      onClick={() =>
                        navigate(`/listing/listing-details/${item?.hash_id}`)
                      }
                      clName={"w-100"}
                      className={"w-100"}
                    />
                    <Box
                      className="d-flex align-items-center justify-content-center contact-btn w-100 gap-1"
                      style={{ cursor: "pointer" }}
                    >
                      <Whatsapp width={25} height={24} />
                      <SpanStyled
                        color="var(--themeColorSecondary)"
                        className="text-nowrap"
                      >
                        {t("contact_us")}
                      </SpanStyled>
                    </Box>
                  </Box>
                </Box>
              </Box>
            ))}
        </Box>
      ) : (
        <Box className="d-flex justify-content-center">
          <HeadingStyled>{t("no_listing_found")}</HeadingStyled>
        </Box>
      )}
      {!showAll && propertiesList?.length > 3 && (
        <Box className="w-100 d-flex justify-content-center mt-2">
          <ButtonStyled
            label={t("ViewAll")}
            bg="var(--white)"
            iconAfter={language == "en" ? BackwardArrow : ForwardArrow}
            border="var(--border)"
            color="var(--themeColorSecondary)"
            onClick={() => setShowAll(true)}
          />
        </Box>
      )}
      <AddPropertyModal
        show={showModal}
        onHide={() => setShowModal(false)}
        getPropertiesList={getPropertiesList}
      />
      <EditPropertyModal
        show={showEditModal}
        onHide={() => setShowEditModal(false)}
        getPropertiesList={getPropertiesList}
        id={propertyId}
        setId={setPropertyId}
      />
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
        title={t("property")}
      />

      <GalleryModal
        show={showGallery}
        onHide={handleGalleryClose}
        type={"images"}
        items={galleryImages}
      />
    </>
  );
};

export default PopertiesCards;
